
const TemplatePreview = ({ previewData }) => {
  if (!previewData) return null;

  return (
    <div className="bg-white p-2 rounded-lg shadow-md w-full max-w-sm border border-gray-300 sticky top-6">
      <h3 className="text-lg font-semibold mb-4">Template preview</h3>

      {/* WhatsApp wallpaper as background */}
      <div
        className="p-4 rounded-lg shadow-inner"
        style={{
          backgroundImage:
            "url('https://e0.pxfuel.com/wallpapers/722/149/desktop-wallpaper-message-background-whatsapp-message-background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Single static preview card */}
        <div className="border rounded-lg overflow-hidden shadow-md bg-white/90 backdrop-blur-sm">
          {/* Image Section */}
          {previewData.image && (
            <img
              src={previewData.image}
              alt="Template preview"
              className="w-full h-40 object-cover"
            />
          )}

          {/* Content Section */}
          <div className="p-4">
            <p className="text-sm font-medium mb-2">{previewData.title}</p>
            <p className="text-sm mb-2">{previewData.message}</p>

            {/* Code Section (for Authentication) */}
            {previewData.code && (
              <div className="bg-gray-100 p-3 rounded text-center my-3">
                <span className="text-2xl font-bold text-blue-600">
                  {previewData.code}
                </span>
              </div>
            )}

            <p className="text-sm text-gray-600">{previewData.subtitle}</p>
            <p className="text-xs text-gray-500 text-right mt-2">11:59</p>
          </div>

          {/* Buttons Section */}
          {previewData.buttons && previewData.buttons.length > 0 && (
            <div className="border-t">
              {previewData.buttons.map((button, index) => (
                <button
                  key={index}
                  className={`w-full flex items-center justify-center gap-2 py-2 font-medium hover:bg-gray-100 ${
                    index > 0 ? "border-t" : ""
                  } ${button.color}`}
                >
                  {button.icon}
                  {button.text}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Template Information */}
      <div className="mt-4 text-gray-700 leading-relaxed">
        <p className="text-base font-semibold tracking-wide mb-1">
          This template is good for
        </p>
        <p className="text-sm text-gray-600 mb-4">{previewData.goodFor}</p>

        <p className="text-base font-semibold tracking-wide mb-1">
          Template areas that you can customize
        </p>
        <p className="text-sm text-gray-600">{previewData.customizable}</p>
      </div>
    </div>
  );
};

export default TemplatePreview;
